import { useQuery } from "@tanstack/react-query"
import { useSelector } from "react-redux"
import { API_SBP_COMBINED_PAYMENTS_MBANK_URL } from "../constants"
import { axios } from "../axios"
import { checkIsFailure } from "../utils/utils"
import { RootState } from "../../store/store"
import { PaymentCheckResponse } from "../../types/payments"

const getPaymentCheck = async (data: { amount: number}, token: string) => {
  try {
    const response = await axios<PaymentCheckResponse>(
      `${API_SBP_COMBINED_PAYMENTS_MBANK_URL}/check`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data,
      },
    )

    if (checkIsFailure(response.status)) {
      throw new Error(
        `Ошибка: ${response.status} - ${response.statusText}. Попробуйте еще раз.`,
      )
    }

    if (!response.data?.exchangeRate) {
        throw new Error(
          `Ошибка получения курса`,
        )
    }

    return response.data
  } catch (error) {
    throw new Error(
      `Ошибка получения курса`,
    )
  }

}


export const usePaymentCheck = (amount: number) => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery<PaymentCheckResponse>({
    queryKey: ["combined-payments/check", amount],
    queryFn: () => getPaymentCheck({ amount }, token || ""),
    enabled: false,
    retry: false,
  })
}